var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.duotone_twee{fill:#555D5E;}\r\n\t.duotone_een{fill:#0B1719;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "duotone_een",
    d: "M26.693,18.296l-2.63-7.89c-0.18-0.541-0.945-0.541-1.126,0l-2.63,7.89C20,19,20.759,21.77,23.5,21.77 C26.241,21.77,27,19,26.693,18.296z M23.5,11.879l2.11,6.331h-4.22L23.5,11.879z M11.7,18.296l-2.63-7.89 c-0.18-0.541-0.945-0.541-1.126,0l-2.63,7.89C5.007,19,5.766,21.77,8.507,21.77C11.247,21.77,12.007,19,11.7,18.296z M8.507,11.879 l2.11,6.331h-4.22L8.507,11.879z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "duotone_twee",
    d: "M24.5,9H18V7h6.5C24.776,7,25,7.224,25,7.5v1C25,8.776,24.776,9,24.5,9z M14,7H7.5 C7.224,7,7,7.224,7,7.5v1C7,8.776,7.224,9,7.5,9H14V7z M19.106,26.053L17,25.028V7h-2v18.028l-2.106,1.025 C12.423,26.289,12.59,27,13.118,27h5.764C19.41,27,19.577,26.289,19.106,26.053z M16,4c-0.552,0-1,0.448-1,1s0.448,1,1,1 c0.552,0,1-0.448,1-1S16.552,4,16,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/unit.123ea24d6afa307cfac1b929b57e4fcc.svg";
export { ForwardRef as ReactComponent };